export enum RangesList {
  Today = 'Today',
  ThisWeek = 'This week',
  LastWeek = 'Last week',
  ThisMonth = 'This month',
  LastMonth = 'Last month',
  ThisYear = 'This year (YTD)',
  YearFromToday = 'Last 365 days',
}
